import React, { useEffect, useRef } from 'react'
import loadExternalLibrary from 'util/loadExternalLibrary'
import Slider from 'react-slick'

const PinterestPins = ({ onLoad = function () {}, pinIDs, onPinInteract }) => {
  //https://widgets.pinterest.com/v3/pidgets/pins/info/?pin_ids=262616222001737554&sub=www&callback=PIN_1603812416392.f.callback[10]
  const pinSliderRef = useRef(null)
  useEffect(() => {
    loadExternalLibrary({
      url: '//assets.pinterest.com/js/pinit.js',
      name: '//assets.pinterest.com/js/pinit.js',
    }).then(function () {
      console.log('loaded pinterest')
      onLoad()
    })
  }, [onLoad])

  var sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    initialSlide: 0,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  }

  return (
    <div className="pinterest-slick-container">
      <Slider
        ref={slider => (pinSliderRef.current = slider)}
        {...sliderSettings}
      >
        {pinIDs.map((pin, index) => (
          <div
            className="pinterest-pin-slide"
            key={index}
            onClick={() => onPinInteract(pin)}
          >
            <a
              data-pin-do="embedPin"
              href={`https://www.pinterest.com/pin/${pin}/`}
            ></a>
          </div>
        ))}
      </Slider>
    </div>
  )
}
export default PinterestPins
